@file:Suppress("EXPECT_ACTUAL_CLASSIFIERS_ARE_IN_BETA_WARNING")

package com.wintermar.inspection.feature.domain.usecase.inspection

import com.wintermar.inspection.core.domain.FlowResult
import com.wintermar.inspection.feature.domain.model.VesselModel
import com.wintermar.inspection.feature.domain.model.inspection.InspectionLandingModel
import com.wintermar.inspection.feature.domain.repository.InspectionRepository
import kotlinx.coroutines.flow.Flow

actual class GetListInspectionUseCaseImpl actual constructor(val inspectionRepository: InspectionRepository) :
    GetListInspectionUseCase {
    actual override operator fun invoke(
        vesselList: List<VesselModel>,
        page: Int,
        pageSize: Int,
        isRefreshData: Boolean
    ): Flow<FlowResult<InspectionLandingModel>> {
        return inspectionRepository.getInspections(vesselList, page, pageSize)
    }
}
